import { render, staticRenderFns } from "./notifications.vue?vue&type=template&id=b6404f64&scoped=true&"
import script from "./notifications.vue?vue&type=script&lang=js&"
export * from "./notifications.vue?vue&type=script&lang=js&"
import style0 from "./notifications.vue?vue&type=style&index=0&id=b6404f64&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6404f64",
  null
  
)

export default component.exports